import { SHOW_NOTIFICATION } from '../actions/types/NotificationActionTypes';

export default (state = null, action) => {
  switch (action.type) {
    case SHOW_NOTIFICATION:
      return action.payload.notification;
    default:
      return state;
  }
};
